import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  NgbTooltipModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { MasterInformationService } from '../../../Services/master-information.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { DashboardService } from '../../../Services/dashboard.service';
import { ReportsService } from '../../../Services/reports.service';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-order-summary',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgbTooltipModule,
    NgbPaginationModule,
    ToastrModule,
  ],
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.css'],
})
export class OrderSummaryComponent implements OnInit {
  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 12;

  // Filters
  yearFilter: string = '';
  monthFilter: string = '';
  cityFilter: string = '';
  zoneFilter: string = '';
  requestorFilter: string = '';

  // Options for dropdowns
  months = [
    { id: 1, name: 'January' },
    { id: 2, name: 'February' },
    { id: 3, name: 'March' },
    { id: 4, name: 'April' },
    { id: 5, name: 'May' },
    { id: 6, name: 'June' },
    { id: 7, name: 'July' },
    { id: 8, name: 'August' },
    { id: 9, name: 'September' },
    { id: 10, name: 'October' },
    { id: 11, name: 'November' },
    { id: 12, name: 'December' },
  ];
  allOrderSummary: any;
  listYear: any;
  cityList: any;
  zoneList: any;
  selectedCityId: any;
  selectedZoneId: any;
  userTypeList: any;
  selectedUserType: any;
  yearsList: number[] = [];
  selectedYear: any;
  selectedMonthId: any;
  userList: any;
  filteredList: any;
  years: number[] = [];
  fromDate: any;
  isToDateShow: boolean = false;
  toDate: any;
  ngFromDate: any;
  ngToDate: any;

  constructor(
    private reportService: ReportsService,
    private masterService: MasterInformationService,
    private toastr: ToastrService,
    private dashService: DashboardService
  ) {}

  //  ----------------------------------- OnInit ----------------------------------- //

  ngOnInit() {
    this.getFilteredOrderSummary();
    this.getCity();
    this.getUserType();
    this.generateYears(2025);
  }

  //  ----------------------------------- Pagination ----------------------------------- //

  onPageChange(page: number) {
    this.page = page;
  }

  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.filteredList?.slice(start, end);
  }

  //  ----------------------------------- Get UserType List ----------------------------------- //

  getUserType() {
    this.reportService.getUserTypeList(apiEndPoints.userType).subscribe({
      next: (response: any) => {
        let userType = [1, 2];
        this.userTypeList = response.body.details?.filter((item: any) =>
          userType.includes(item.id)
        );
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  //  ----------------------------------- On UserType Change ----------------------------------- //

  onUserTypeChange(event: any) {
    const selectedUserType = (event.target as HTMLSelectElement).value;
    this.selectedUserType = selectedUserType;
    this.getFilteredOrderSummary();
  }

  // ----------------------------------- Get All City List API ----------------------------------- //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.cityList = response.body.details;
      },
      error: (error) => {
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event) {
    const selectedCity = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCity;
    this.getZone();
    this.getFilteredOrderSummary();
  }

  // ----------------------------------- Get All Zone List API ----------------------------------- //

  getZone() {
    this.dashService
      .getZoneList(apiEndPoints.zoneList, this.selectedCityId)
      .subscribe({
        next: (response: any) => {
          this.zoneList = response.body.details;
        },
        error: (error) => {
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // ----------------------------------- Zone Change Dropdown ----------------------------------- //

  onZoneChange(event: Event) {
    const selectedZoneId = (event.target as HTMLSelectElement).value;
    this.selectedZoneId = selectedZoneId;
    this.getFilteredOrderSummary();
  }

  // ----------------------------------- Year Change Dropdown ----------------------------------- //

  generateYears(startYear: number) {
    const currentYear = new Date().getFullYear();
    for (let year = startYear; year <= currentYear; year++) {
      this.years.push(year);
    }
  }

  onYearChange(event: any) {
    const selectedYear = (event.target as HTMLSelectElement).value;
    this.selectedYear = selectedYear;
    this.getFilteredOrderSummary();
  }

  onMonthChange(event: any) {
    const selectedMonthId = (event.target as HTMLSelectElement).value;
    this.selectedMonthId = selectedMonthId;
    this.getFilteredOrderSummary();
  }

  // ----------------------------------- Get Filtered Order Summary List API ----------------------------------- //

  getFilteredOrderSummary() {
    this.reportService
      .getFilteredOrderSummary(
        apiEndPoints.orderSummary,
        this.selectedUserType,
        this.selectedCityId,
        this.selectedZoneId,
        this.selectedYear,
        this.fromDate,
        this.toDate
      )
      .subscribe({
        next: (response: any) => {
          this.yearsList = response.body.details.year;
          this.filteredList = response.body.details.orderSummaryMonthlyList;
        },
      });
  }

  // ----------------------------------- Date Filter ----------------------------------- //

  onFromDateChange(event: any) {
    this.fromDate = event.target.value;
    this.isToDateShow = true;
    this.ngToDate = '';
    this.toDate = '';
  }

  onToDateChange(event: any) {
    this.toDate = event.target.value;
    if (new Date(this.toDate) < new Date(this.fromDate)) {
      this.toastr.info('To Date cannot be before From Date!', 'Info', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
        progressBar: true,
      });
      this.ngToDate = '';
      this.toDate = '';
      return;
    }
    this.getFilteredOrderSummary();
  }

  // ----------------------------------- Total Calculation ----------------------------------- //

  get totalContainers() {
    return this.pagedData?.reduce(
      (sum: any, order: any) => sum + order.noOfContainerBooked,
      0
    );
  }

  get totalTrips() {
    return this.pagedData?.reduce(
      (sum: any, order: any) => sum + order.noOfTripAchieved,
      0
    );
  }

  get totalQuantity() {
    return this.pagedData?.reduce(
      (sum: any, order: any) => sum + order.totalTonDisposed,
      0
    );
  }

  // Clear Filters
  clearFilters() {
    this.fromDate = '';
    this.toDate = '';
    this.yearFilter = '';
    this.monthFilter = '';
    this.cityFilter = '';
    this.zoneFilter = '';
    this.requestorFilter = '';
    this.getFilteredOrderSummary();
  }

  // Apply selected filter (from dropdown)
  applyFilter(filterType: any, value: any) {
    switch (filterType) {
      case 'year':
        this.yearFilter = value;
        break;
      case 'month':
        this.monthFilter = value;
        break;
      case 'city':
        this.cityFilter = value;
        break;
      case 'zone':
        this.zoneFilter = value;
        break;
    }
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.filteredList);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'Monthly Summary Report.xlsx');
  }

  exportToPDF() {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.width;
    const pdfFileName = 'Monthly-Summary-Report.pdf';

    const logo = new Image();
    logo.src = 'assets/Images/CDM-01.png';
    logo.onload = () => {
      const logoWidth = 28;
      const logoHeight = 20;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 10;
      doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);

      const arabicAddressImg = new Image();
      arabicAddressImg.src = 'assets/Images/arabic address.jpeg';
      arabicAddressImg.onload = () => {
        const arabicImgWidth = 70;
        const arabicImgHeight = 20;
        const arabicImgX = pageWidth - arabicImgWidth - 10;
        const arabicImgY = 10;
        doc.addImage(
          arabicAddressImg,
          'JPEG',
          arabicImgX,
          arabicImgY,
          arabicImgWidth,
          arabicImgHeight
        );

        // Add website below Arabic address image
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 255);
        doc.text(
          'www.smart­sort.net',
          arabicImgX + arabicImgWidth / 2,
          arabicImgY + arabicImgHeight + 5,
          { align: 'left' }
        );

        const englishAddressImg = new Image();
        englishAddressImg.src = 'assets/Images/english address.jpeg';
        englishAddressImg.onload = () => {
          const englishImgWidth = 70;
          const englishImgHeight = 20;
          const englishImgX = 10;
          const englishImgY = 10;
          doc.addImage(
            englishAddressImg,
            'JPEG',
            englishImgX,
            englishImgY,
            englishImgWidth,
            englishImgHeight
          );

          // Add website below English address image
          doc.setFontSize(10);
          doc.setTextColor(0, 0, 255);
          doc.text(
            'www.smart­sort.net',
            englishImgX + englishImgWidth / 11,
            englishImgY + englishImgHeight + 5,
            { align: 'left' }
          );

          // Reset text color to black (optional, in case you add more text later)
          doc.setTextColor(0, 0, 0);

          doc.setFont('helvetica', 'bold');
          doc.setFontSize(14);
          const title = 'Monthly Summary Report';
          const titleY = logoY + logoHeight + 10;
          doc.text(title, pageWidth / 2, titleY, { align: 'center' });

          // Table headers
          const headers = [
            [
              { content: 'Month' },
              { content: 'No. of Containers Booked' },
              { content: 'No. of Trips Achieved' },
              { content: 'Total Tons Disposed' },
            ],
          ];

          let tableBody: any[] = [];

          // Ensure Year is filled for every row
          this.pagedData.forEach((summary: any) => {
            tableBody.push([
              summary.month,
              summary.noOfContainerBooked,
              summary.noOfTripAchieved,
              summary.totalTonDisposed,
            ]);
          });

          // Add footer row with totals
          const footer = [
            'Total',
            this.totalContainers,
            this.totalTrips,
            this.totalQuantity,
          ];
          tableBody.push(footer);

          // Generate table
          autoTable(doc, {
            startY: titleY + 10,
            head: headers,
            body: tableBody,
            styles: {
              fontSize: 8,
              cellPadding: 2,
              lineWidth: 0.3,
              lineColor: [50, 50, 50],
              halign: 'center',
            },
            theme: 'grid',
            headStyles: {
              fillColor: [176, 220, 101],
              textColor: [0, 0, 0],
              fontStyle: 'bold',
              lineColor: [50, 50, 50],
              lineWidth: 0.3,
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: { 0: { halign: 'center', fontStyle: 'bold' } },
            margin: { top: titleY + 20 },
            pageBreak: 'auto',
            rowPageBreak: 'avoid',
            didDrawPage: function (data) {
              const pageCount = doc.getNumberOfPages();
              doc.setFontSize(10);
              doc.text(
                `Page ${pageCount}`,
                pageWidth - 20,
                doc.internal.pageSize.height - 10
              );
            },
          });

          // Save the PDF
          doc.save(pdfFileName);
        };
      };
    };
  }
}
